export default __webpack_public_path__ + "static/media/checked.62314943.svg";